import React from "react";
import { connect } from "react-redux";
import "./styles/AdList.css";
import { Translate } from "react-redux-i18n";
import * as actions from "../redux/actions/adActions";
import ProductCard, { getKindCommerceLabel } from "./ProductCard";

class AdList extends React.Component {
  onClick = (item) => {
    this.props.SetAd(item);
  };

  render() {
    if (this.props.adList.length === 0)
      return (
        <h3>
          <Translate value="ad_not_list" />
        </h3>
      );

    return (
      <div className="product-card-list">
        {this.props.adList.map((ad) => (
          <ProductCard
            key={ad.Id}
            item={ad}
            kindCommerce={getKindCommerceLabel(ad.KindCommerceId)}
            onClick={() => this.onClick(ad)}
          />
        ))}
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  SetAd: (item) => dispatch(actions.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdList);
